import { useState } from "react";
import { FaShareAlt, FaWhatsapp, FaFacebookF, FaLink, FaCheck } from "react-icons/fa";
import "./ShareTutorButton.css";

// Points at the backend OG endpoint so shared links show a rich preview
// (tutor name + photo + subject) and redirect humans to the profile.
const SHARE_ORIGIN =
  import.meta.env.VITE_SHARE_ORIGIN ||
  import.meta.env.VITE_APP_BASE_URL ||
  "https://api.xplooreze.in";

export default function ShareTutorButton({ tutorId, tutorName, category }) {
  const [openMenu, setOpenMenu] = useState(false);
  const [copied, setCopied] = useState(false);

  if (!tutorId) return null;

  const shareUrl = `${SHARE_ORIGIN}/share/tutor/${tutorId}`;
  const text = `Check out ${tutorName || "this tutor"}${
    category ? `, a ${category} tutor` : ""
  } on Xplooreze:`;
  const waText = encodeURIComponent(`${text} ${shareUrl}`);
  const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    shareUrl,
  )}`;
  const waUrl = `https://wa.me/?text=${waText}`;

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `${tutorName || "Tutor"} on Xplooreze`,
          text,
          url: shareUrl,
        });
      } catch {
        // user cancelled — ignore
      }
      return true;
    }
    return false;
  };

  const onShareClick = async () => {
    const usedNative = await nativeShare();
    if (!usedNative) setOpenMenu((v) => !v);
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // clipboard blocked — fall back to a prompt
      window.prompt("Copy this link:", shareUrl);
    }
  };

  return (
    <div className="share-tutor-wrap">
      <button
        type="button"
        className="share-tutor-btn"
        onClick={onShareClick}
        aria-label="Share this tutor"
      >
        <FaShareAlt /> Share
      </button>

      {openMenu && (
        <div className="share-tutor-menu">
          <a
            className="share-tutor-item"
            href={waUrl}
            target="_blank"
            rel="noreferrer"
            onClick={() => setOpenMenu(false)}
          >
            <FaWhatsapp style={{ color: "#25D366" }} /> WhatsApp
          </a>
          <a
            className="share-tutor-item"
            href={fbUrl}
            target="_blank"
            rel="noreferrer"
            onClick={() => setOpenMenu(false)}
          >
            <FaFacebookF style={{ color: "#1877F2" }} /> Facebook
          </a>
          <button type="button" className="share-tutor-item" onClick={copyLink}>
            {copied ? (
              <>
                <FaCheck style={{ color: "#059669" }} /> Copied!
              </>
            ) : (
              <>
                <FaLink /> Copy link
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
}
